import { PageHeader } from "~/components/PageHeader";
import { VisualizationGrid } from "~/modules/visualization/components/VisualizationGrid";
import { GlobalAssetTableLayout } from "./GlobalAssetTable/component";
import { HomePageLeagueTable } from "./HomePageLeagueTable";
import { GigatableRow } from "./GlobalAssetTable/types";
import { LeagueTableTabsByDistributionType } from "~/modules/league_tables/types";
import { TopTransfersCard } from "~/modules/transactions/components/TopTransfersCard";
import { TopTransfersData } from "~/modules/transactions/components/TopTransfersCard/types";
import {
    TokenTimeseriesColumns,
    TokenTimeseriesGroupBy,
} from "~/modules/token_timeseries/types";
import { MetricTimeseriesChart } from "~/modules/visualization/components/MetricTimeseriesChart";
import { FilterOperators } from "~/modules/filters/types";
import { ASSET_CLASS_IDS } from "~/consts";
import {
    AggregateGrid,
    Props as AggregateDisplayProps,
} from "~/components/AggregateDisplay";
import { THREE_YEARS_AGO } from "~/modules/visualization/components/TimeSeriesChartV3/consts";

// // // //

export function TotalRwaValueChart() {
    return (
        <MetricTimeseriesChart
            title="Total RWA Value"
            height={450}
            analyticsChartName="home-page-total-rwa-value"
            filters={[
                {
                    field: TokenTimeseriesColumns.assetClassID,
                    operator: FilterOperators.NotEquals,
                    value: ASSET_CLASS_IDS.Cryptocurrency,
                },
            ]}
            controls={{
                legend: {
                    enabled: true,
                    active: true,
                    align: "center",
                    layout: "horizontal",
                    verticalAlign: "bottom",
                    itemWidth: 160,
                },
                navigator: {
                    enabled: true,
                    active: true,
                    xAxis: {
                        min: THREE_YEARS_AGO.getTime(),
                        max: null,
                    },
                },
                groupBy: {
                    enabled: false,
                    value: TokenTimeseriesGroupBy.assetClass,
                },
            }}
            columnSpanConfig={{
                sm: 12,
                md: 12,
                lg: 12,
                xl: 12,
                xxl: 12,
            }}
        />
    );
}

// // // //

export function HomePage(props: {
    gigatableRows: GigatableRow[];
    aggregates: AggregateDisplayProps[];
    leagueTableTabs: LeagueTableTabsByDistributionType;
    topTransfers: TopTransfersData;
}) {
    const { gigatableRows, aggregates, leagueTableTabs, topTransfers } = props;

    return (
        <div className="flex flex-col h-full grow">
            <PageHeader
                title="Global Market Overview"
                subtitle={
                    <p>
                        Welcome to RWA.xyz. Discover every tokenized real-world
                        asset and the broader tokenization ecosystem, from asset
                        managers to tokenization platforms to blockchains.{" "}
                        <span className="text-muted-foreground">
                            Email team@rwa.xyz for questions or help.
                        </span>
                    </p>
                }
            />

            <AggregateGrid aggregates={aggregates} />

            <VisualizationGrid className="my-6">
                <TotalRwaValueChart />

                <HomePageLeagueTable
                    leagueTableTabs={leagueTableTabs}
                    analyticsTableName="homepage-league-table"
                    colSpans={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 6,
                        xxl: 6,
                    }}
                />

                {/* <NewsFeedCard
                    articles={articles}
                    colSpans={{ lg: 12, xl: 6, xxl: 6 }}
                /> */}

                <TopTransfersCard topTransfers={topTransfers} />
            </VisualizationGrid>

            <GlobalAssetTableLayout rows={gigatableRows} />
        </div>
    );
}
